import { Component, Input } from '@angular/core';
import { Wallet } from '../../models/walletmodel';
import { WalletSearch } from '../../models/walletsearchmodel';
import { walletService }   from '../../services/wallet.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import * as alaSQLSpace from 'alasql';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';

@Component({
  templateUrl: './wallet.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [walletService]
})

export class WalletComponent {
  @Input() responseObj: Session;
  public wallets: Wallet[];
  public walletsearch: WalletSearch;
  public enablestorefield: boolean;
  errorMessage: string;
  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: [],
    showTitle: true,
    title: 'asfasf',
    useBom: false,
    removeNewLines: true,
    keys: ['smartcard','entrytype','merchantreference' ]
  };
  public data;
  public objectKeys = Object.keys;
  public transno = 0;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'yyyy-mm-dd',
    
  };

  private selDate: IMyDate = {year: 0, month: 0, day: 0};

 
  constructor(private _walletService: walletService, public router: Router, public sharedservice: SharedService) {
    // // set today to selDate attribute
    // let d: Date = new Date();
    // this.selDate = {year: d.getFullYear(), 
    //                 month: d.getMonth() + 1, 
    //                day: d.getDate()};
             
  }

  ngOnInit()
  {
      // call the method on initial load of page to bind dropdown   
      this.getLast10Transactions();
      this.walletsearch = new WalletSearch();

      if(!this.sharedservice.isAdmin() && !this.sharedservice.isViewer()){
        this.enablestorefield = true;
        this.sharedservice.checkCredentials();
        if(this.sharedservice.isMerchant())
          this.walletsearch.searchstoreid = this.sharedservice.session.account_username;
        else
          this.walletsearch.searchstoreid = this.sharedservice.session.account_userstore;
      }
      else
      {
        this.enablestorefield = false;
      }
  }

      //Get the list of languages
  getLast10Transactions() {
      this._walletService.getLast10WalletTransactions().subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

  onStartDateChanged(event: IMyDateModel) {

    this.walletsearch.searchfromdate = event.formatted;
    // date selected
    //console.log('Formatted date: ', event.formatted);
  }

  onEndDateChanged(event: IMyDateModel) {
    this.walletsearch.searchtodate = event.formatted;
    // date selected
   // console.log('Formatted date: ', event.formatted);
  }


  searchWalletTransaction(isValid: boolean){
    
    if(isValid)
      this._walletService.searchWalletTransaction(this.walletsearch).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);    
  }


  exportXLS() {
    var data = this.wallets;
    var opts = [{ sheetid: 'Data', header: true }];
    alasql('SELECT INTO XLSX("report.xlsx",?) FROM ?', [opts, [data]]);
  }

  exportCSV() {
    var data = this.wallets;
    var opts = [{header: true }];
     alasql('SELECT INTO CSV("report.csv",{header: true}) FROM ?', [opts, data]);
   }

   replacer(i, val) {
    if ( val === null ) { 
        return ""; // Change null to empty  
    } else {
        return val; // return unchanged
    }
  }


  handleResponse(result){
    this.wallets = JSON.parse(JSON.stringify(result, this.replacer));
    this.data = this.wallets; 
  }


}



// WEBPACK FOOTER //
// /tmp/build_713add00/src/app/wallet/wallet.component.ts